var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaneHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29418",
    "data-name": "Group 29418",
    transform: "translate(-8 -502.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(8 502.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29417",
    "data-name": "Group 29417",
    transform: "translate(-0.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50774",
    "data-name": "Path 50774",
    d: "M24.142,297.138l-2.853-2.244a.348.348,0,0,1-.113-.46,1.829,1.829,0,0,1,2.2-.566l2.58,1.464Zm.957.957,2.25,2.859a.348.348,0,0,0,.46.113l.17-.117a1.547,1.547,0,0,0,.479-1.864l-1.546-2.8Z",
    transform: "translate(5.552 228.461)",
    fill: "#ff2c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50775",
    "data-name": "Path 50775",
    d: "M64.5,311.655l-1.614,1.6,1.448,1.139,1.817-1.806Z",
    transform: "translate(-34.638 211.202)",
    fill: "#e62753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50776",
    "data-name": "Path 50776",
    d: "M114.7,57.849a.987.987,0,0,1-.067-1.322c.458-.562,1.031-1.187,1.375-1.531a3.449,3.449,0,0,1,1.015-.723.188.188,0,0,1,.231.027l.994.994a.188.188,0,0,1,.027.231,3.449,3.449,0,0,1-.723,1.015c-.344.344-.97.918-1.531,1.375A.987.987,0,0,1,114.7,57.849Zm8.978,8.978a.987.987,0,0,1-.067-1.322c.458-.562,1.031-1.187,1.375-1.531A3.448,3.448,0,0,1,126,63.251a.188.188,0,0,1,.231.027l.994.994a.188.188,0,0,1,.027.231,3.449,3.449,0,0,1-.723,1.015c-.344.344-.97.918-1.531,1.375A.987.987,0,0,1,123.679,66.827Z",
    transform: "translate(-84.232 458.963)",
    fill: "#c3d3db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50773",
    "data-name": "Path 50773",
    d: "M9.069,61.947l3.519-3.519L1.686,55a.616.616,0,0,0-.6.146l-.921.921a.72.72,0,0,0,.259,1.108l8.641,4.77Z",
    transform: "translate(25.889 458.256)",
    fill: "#ff2c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50777",
    "data-name": "Path 50777",
    d: "M189.42,126.308l-3.142,3.142,2.086,1.152,3.519-3.519Z",
    transform: "translate(-153.405 389.601)",
    fill: "#e62753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50778",
    "data-name": "Path 50778",
    d: "M271.16,179.712l3.519-3.519,3.425,10.9a.616.616,0,0,1-.146.6l-.921.921a.72.72,0,0,1-1.108-.259Z",
    transform: "translate(-235.105 341.587)",
    fill: "#ff2c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50779",
    "data-name": "Path 50779",
    d: "M89.034,5.125l-5.913,5.913A32.048,32.048,0,0,1,79.97,13.8l-2.813,2.158a1.424,1.424,0,0,1-1.842.144,1.425,1.425,0,0,1,.144-1.842l2.158-2.813A32.049,32.049,0,0,1,80.382,8.3l5.913-5.913A9.819,9.819,0,0,1,89.011.441c.845-.4,1.742-.648,2.178-.212s.187,1.334-.212,2.178a9.817,9.817,0,0,1-1.944,2.717Z",
    transform: "translate(-46.337 511.174)",
    fill: "#e0f3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50780",
    "data-name": "Path 50780",
    d: "M91.482.254a.865.865,0,0,0-.61-.229,3.746,3.746,0,0,1-.44,1.583,9.818,9.818,0,0,1-1.944,2.717l-5.913,5.913A32.043,32.043,0,0,1,79.424,13l-2.813,2.158a1.8,1.8,0,0,1-1.268.41.955.955,0,0,0,.264.557,1.425,1.425,0,0,0,1.842-.144l2.813-2.158a32.05,32.05,0,0,0,3.151-2.765l5.913-5.913A9.82,9.82,0,0,0,91.27,2.432c.4-.845.648-1.742.211-2.178Z",
    transform: "translate(-46.629 511.15)",
    fill: "#c3d3db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50781",
    "data-name": "Path 50781",
    d: "M402.1,49.262l-.2.2c-.187.188-2.285-1.91-2.1-2.1l.2-.2a.424.424,0,0,1,.466-.1A3.456,3.456,0,0,1,402.2,48.8.424.424,0,0,1,402.1,49.262Z",
    transform: "translate(-358.908 465.905)",
    fill: "#51c4f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50782",
    "data-name": "Path 50782",
    d: "M92.222,342.584a.281.281,0,0,1-.2-.48l2.455-2.455a.281.281,0,0,1,.4.4L92.421,342.5A.28.28,0,0,1,92.222,342.584Z",
    transform: "translate(-62.604 184.336)",
    fill: "#e62753"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneHighlighted);
export default __webpack_public_path__ + "static/media/planeHighlighted.c21b8cade304e11144c20b5fe60fd80c.svg";
export { ForwardRef as ReactComponent };